'use client';

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface VoiceAgentContextType {
  isVoiceAgentEnabled: boolean;
  toggleVoiceAgent: () => void;
  setVoiceAgentEnabled: (enabled: boolean) => void;
}

const VoiceAgentContext = createContext<VoiceAgentContextType | undefined>(undefined);

interface VoiceAgentProviderProps {
  children: ReactNode;
}

export const VoiceAgentProvider: React.FC<VoiceAgentProviderProps> = ({ children }) => {
  const [isVoiceAgentEnabled, setIsVoiceAgentEnabled] = useState<boolean>(false);

  // Persistence removed to ensure dormant state by default as per user request
  /*
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('voiceAgentEnabled');
      if (saved !== null) setIsVoiceAgentEnabled(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('voiceAgentEnabled', JSON.stringify(isVoiceAgentEnabled));
    }
  }, [isVoiceAgentEnabled]);
  */

  const toggleVoiceAgent = () => {
    setIsVoiceAgentEnabled(prev => !prev);
  };

  const setVoiceAgentEnabled = (enabled: boolean) => {
    setIsVoiceAgentEnabled(enabled);
  };

  const value: VoiceAgentContextType = {
    isVoiceAgentEnabled,
    toggleVoiceAgent,
    setVoiceAgentEnabled,
  };

  return (
    <VoiceAgentContext.Provider value={value}>
      {children}
    </VoiceAgentContext.Provider>
  );
};

export const useVoiceAgent = (): VoiceAgentContextType => {
  const context = useContext(VoiceAgentContext);
  if (context === undefined) {
    throw new Error('useVoiceAgent must be used within a VoiceAgentProvider');
  }
  return context;
};
